import { Component } from "react"
import PropTypes from "prop-types"
import { TextField, InputAdornment } from "@mui/material"

export default class RangeValueFilter extends Component {
  static propTypes = {
    values: PropTypes.arrayOf(PropTypes.string).isRequired,
    dataType: PropTypes.string.isRequired,
    setValues: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  }

  setMin = e => {
    const { setValues } = this.props
    setValues(e.target.value)
  }

  setMax = e => {
    const { setValues } = this.props
    setValues(undefined, e.target.value)
  }

  render() {
    const { values, dataType, disabled } = this.props

    return <>
      <TextField
        variant="standard"
        className="value"
        value={values[0] === undefined ? "" : values[0]}
        onChange={this.setMin}
        disabled={disabled}
        slotProps={{
          input: {
            startAdornment: dataType === "percent" ? <InputAdornment position="start">%</InputAdornment> : null,
          },
        }}
      />
      <div className="and">and</div>
      <TextField
        variant="standard"
        className="value"
        value={values[1] === undefined ? "" : values[1]}
        onChange={this.setMax}
        disabled={disabled}
        slotProps={{
          input: {
            startAdornment: dataType === "percent" ? <InputAdornment position="start">%</InputAdornment> : null,
          },
        }}
      />
    </>
  }
}
